// extracted by mini-css-extract-plugin
export default {"homeCadre":"Home_homeCadre__JVcGv","sHomeCadre":"Home_sHomeCadre__3itP2","homeStyle":"Home_homeStyle__T-TRj"};